module.exports = __webpack_public_path__ + "media/mobile-header-by.e1d2a546.mp4";